import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "tab-header" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "tab-content" }

import { ref, computed } from "vue";
    import IncomeCharts from "@/guiide/components/charts/IncomeCharts.vue";
    import PotsChart from "@/guiide/components/charts/PotsChart.vue";
    import SubSection from "@/guiide/components/common/SubSection.vue";
    import HelpText from "@/guiide/ts/helpText";
    import { retireeDescriber } from "@/guiide/ts/retireeDescriber";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'IncomeAndPots',
  setup(__props) {

    const selectedTabIndex = ref(0);

    const chartDataHasLoaded = ref(true);

    const incomeChartDescription = computed<string>(() => "Your income chart. A description of the chart: " + retireeDescriber.getIncomeChartDescription());
    const potsChartDescription = computed<string>(() => "Your pots chart. A description of the chart: " + retireeDescriber.getPotsChartDescription());

    function onTabClick(index: number) {
        selectedTabIndex.value = index;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SubSection, {
    title: "Can you still expect to get what you want?",
    helpTitle: "What to take each year",
    helpText: _unref(HelpText).incomeAndPotsCharts()
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", {
            class: _normalizeClass({ 'tab-selected': selectedTabIndex.value == 0, 'tab-unselected': selectedTabIndex.value != 0 })
          }, [
            _createElementVNode("button", {
              role: "button",
              tabindex: "0",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onTabClick(0))),
              onKeyup: [
                _cache[1] || (_cache[1] = _withKeys(($event: any) => (onTabClick(0)), ["enter"])),
                _cache[2] || (_cache[2] = _withKeys(($event: any) => (onTabClick(0)), ["space"]))
              ],
              "aria-label": incomeChartDescription.value
            }, " Income ", 40, _hoisted_3)
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({ 'tab-selected': selectedTabIndex.value == 1, 'tab-unselected': selectedTabIndex.value != 1 })
          }, [
            _createElementVNode("button", {
              role: "button",
              tabindex: "0",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (onTabClick(1))),
              onKeyup: [
                _cache[4] || (_cache[4] = _withKeys(($event: any) => (onTabClick(1)), ["enter"])),
                _cache[5] || (_cache[5] = _withKeys(($event: any) => (onTabClick(1)), ["space"]))
              ],
              "aria-label": potsChartDescription.value
            }, " Your Pots ", 40, _hoisted_4)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(IncomeCharts)
          ], 512), [
            [_vShow, selectedTabIndex.value == 0]
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(PotsChart)
          ], 512), [
            [_vShow, selectedTabIndex.value == 1]
          ])
        ])
      ], 512), [
        [_vShow, chartDataHasLoaded.value]
      ])
    ]),
    _: 1
  }, 8, ["helpText"]))
}
}

})